import { getCMSImageURL } from "@/helpers/CMSImageURL";
import { ROUTES } from "@/routes/appRoutes";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const getCoverForDevice = (covers = [], targetDevice) =>
  covers.find(({ device, src }) => device === targetDevice && src)?.src;

const CategoryCard = ({ item, href }) => {
  const tvCoverSrc = getCoverForDevice(item.covers, "TV");
  const lgCoverSrc = getCoverForDevice(item.covers, "LG");
  const coverSrc = tvCoverSrc || lgCoverSrc;
  const coverUrl = getCMSImageURL(coverSrc, {
    width: 800,
    quality: 85,
  });
  const lgCoverUrl = getCMSImageURL(lgCoverSrc, {
    width: 800,
    quality: 85,
  });

  return (
    <Link
      href={href}
      className="group relative h-[180px] md:aspect-video md:h-auto "
    >
      <div className=" w-full justify-self-center overflow-hidden rounded-[0.9rem] border border-solid border-white/10 bg-[#262626] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-white/80 transition-transform duration-300 ease-out group-hover:scale-150 relative h-[180px] md:aspect-video md:h-auto group-hover:z-[99]" >
        {coverUrl && (
          <picture>
            {lgCoverUrl && (
              <source media="(min-width: 1024px)" srcSet={lgCoverUrl} />
            )}
            <Image
              src={coverUrl}
              alt=""
              fill
              unoptimized
              sizes="(max-width: 767px) calc(100vw - 24px), (max-width: 1023px) 50vw, (max-width: 1279px) 33vw, 25vw"
              className="object-cover "
            />
          </picture>
        )}

        <div
          aria-hidden="true"
          className="absolute inset-y-0 right-0 z-10 w-4/5"
          style={{
            background:
              "linear-gradient(to left, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.58) 45%, rgba(0, 0, 0, 0) 100%)",
          }}
        />

        <span className="absolute bottom-0 right-0 z-20 max-w-[80%] pb-[1.2rem] pl-5 pr-6 pt-4 text-right text-[2rem] font-semibold leading-snug text-primary-white">
          {item.name}
        </span>
      </div>
    </Link>
  );
};

const Category = ({ title, categoryItems, genreItems }) => {
  return (
    <div className="h-auto w-full px-3 md:container md:mx-auto md:pt-32 flex flex-col justify-start items-start">
      <h3 className="mb-[2rem] pr-4 text-[2rem] font-bold text-primary-white md:pr-0">
        {title}
      </h3>
      <div className="grid w-full grid-cols-1 gap-x-4 gap-y-5 md:grid-cols-2 md:gap-5 lg:grid-cols-3 lg:gap-6 xl:grid-cols-4">
        {categoryItems?.map((item) => {
          return (
            <CategoryCard
              key={item._id}
              item={item}
              href={ROUTES.category + "/" + item.slug}
            />
          );
        })}
        {genreItems?.map((item) => {
          return (
            <CategoryCard
              key={item._id}
              item={item}
              href={ROUTES.genre + "/" + item.slug}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Category;
